module.exports = __webpack_public_path__ + "img/TU.84cd6ca9.png";